import { FC } from 'react';
import GridItem from '../../../layout/GridComponents/GridItem';
import CustomTable from '../../../tables/CustomTable';
import {
  LiquidityOverviewData,
  generateLiquidityOverviewColumns,
  generateLiquidityOverviewData,
} from './data';
import { RSOverviewPageModel } from '../../../../types/server-data/ClientConfig';

export interface LiquidityOverviewTableProps {
  overviewData: RSOverviewPageModel<any[]>;
  reportsList: any; // raw reports list payload (or legacy shape)
  clientName: string;
  section: string;
}

const LiquidityOverviewTable: FC<LiquidityOverviewTableProps> = ({
  overviewData,
  reportsList,
  clientName,
  section,
}) => {
  const columns = generateLiquidityOverviewColumns(clientName, section);
  const data = generateLiquidityOverviewData(
    overviewData.data,
    reportsList,
    (section as 'ucits' | 'sif-raif' | 'aifmd' | 'nurs' | 'act40') || 'ucits',
  );

  return (
    <GridItem xs={12} card>
      <CustomTable<LiquidityOverviewData>
        options={{ paging: false, search: true, exportButton: true }}
        columns={columns}
        data={data}
        showToolbar={true}
        title="Liquidity Overview Data"
      />
    </GridItem>
  );
};

export default LiquidityOverviewTable;
